import { api } from "./client";

export type ConversationRow = {
  id: string;
  title: string | null;
  first_user_prompt: string | null;
  turn_count: number;
  has_tool_calls: boolean;
  tool_integrations: string[];
  created_at: string;
  updated_at: string | null;
  user_email: string;
  user_name: string;
  user_department: string | null;
};

export type TurnRow = {
  idx: number;
  role: "user" | "assistant";
  content_plain: string | null;
  content_length: number;
  tool_call_count: number;
  file_count: number;
  attachment_count: number;
  created_at: string;
};

export const conversationsApi = {
  list: (params?: { user_id?: number; limit?: number; offset?: number }) => {
    const q = new URLSearchParams();
    if (params?.user_id) q.set("user_id", String(params.user_id));
    if (params?.limit) q.set("limit", String(params.limit));
    if (params?.offset) q.set("offset", String(params.offset));
    const qs = q.toString();
    return api.get<ConversationRow[]>(`/conversations${qs ? `?${qs}` : ""}`);
  },
  getTurns: (id: string) => api.get<TurnRow[]>(`/conversations/${id}/turns`),
};
